import { Text } from '@mds/web-ui-text';

interface TitleProps {
  title: string;
  descriptor: string;
}

const Title: React.FC<TitleProps> = ({ title, descriptor }) => {
  return (
    <div style={{ paddingBottom: '20px' }}>
      <div style={{ paddingBottom: '10px' }}>
        <Text textStyle="titleExtraLarge">{title}</Text>
        <hr />
      </div>
      <Text textStyle="bodyLarge">{descriptor}</Text>
    </div>
  );
};

export default Title;
